import { createStateContext } from '@change-corgi/core-react/context';

import { INITIAL_STATE } from './initialState';
import { mutations } from './mutations';
import type { AmbassadorsPageState } from './types';

/** @knip-ignore */
export const {
	StateContext: AmbassadorsPageStateContext,
	StateProvider: AmbassadorsPageStateContextProvider,
	useStateContext: useAmbassadorsPageState,
} = createStateContext<AmbassadorsPageState, typeof mutations>({
	name: 'AmbassadorsPageStateContext',
	mutations,
	initialState: INITIAL_STATE,
});
